import { render, staticRenderFns } from "./CustomerCustomerMessageDevices.vue?vue&type=template&id=4222e6f6"
import script from "./CustomerCustomerMessageDevices.vue?vue&type=script&lang=js"
export * from "./CustomerCustomerMessageDevices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports